import { TranslationMessages } from 'react-admin';
import englishMessages from 'ra-language-english';

const customEnglishMessages: TranslationMessages = {
  ...englishMessages,
  auth: {
    sso_sign_in: 'SSO SIGN IN',
  },
  pos: {
    search: 'Search',
    configuration: 'Configuration',
    language: 'Language',
    theme: {
      name: 'Theme',
      light: 'Light',
      dark: 'Dark',
    },
    dashboard: {
      monthly_revenue: 'Monthly Revenue',
      claims_data: 'Claims',
      month_history: '30 Day Revenue History',
      new_orders: 'New Orders',
      pending_reviews: 'Pending Reviews',
      all_reviews: 'See all reviews',
      new_customers: 'New Customers',
      all_customers: 'See all customers',
      pending_orders: 'Pending Orders',
      order: {
        items: 'by %{customer_name}, one item |||| by %{customer_name}, %{nb_items} items',
      },
      welcome: {
        title: 'Welcome to the Billing Mart',
        /*subtitle:
                    "This is the admin of an imaginary poster shop. Feel free to explore and modify the data - it's local to your computer, and will reset each time you reload.",
                ra_button: 'react-admin site',
                demo_button: 'Source for this demo',*/
      },
    },
    menu: {
      sales: 'Sales',
      catalog: 'Catalog',
      customers: 'Customers',
    },
    events: {
      review: {
        title: 'Posted review on "%{product}"',
      },
      order: {
        title: 'Ordered 1 poster |||| Ordered %{smart_count} posters',
      },
    },
  },
  notifications: {
    CONFIG_SAVED: 'Configuration saved successfully.',
    CONFIG_DELETED: 'Configuration deleted successfully.',
    CONFIG_CLONED_READY_FOR_SAVE:
      'Settings from %{sourceName} have been loaded into the form for %{targetName}. Review and click "Save Configuration" to apply them.',
    CONFIG_FAILED: 'Error saving configuration.',
    CONFIG_LOADED: 'Configuration loaded.',
    CONFIG_NO_SAVED_CONFIG: 'No saved configuration for this client.',
    CONFIG_FAILED_TO_FETCH: 'Failed to fetch configuration.',
    CONFIG_CLIENT_OR_CONFIG_MISSING: 'No configuration loaded or client selected.',
    CONFIG_NO_CHANGES: 'No changes detected. Configuration not saved.',
    CONFIG_NO_FIELDS_SELECTED: 'No fields selected. Please select at least one field.',
    CONFIG_SOURCE_EMPTY_NO_FORM_CHANGE:
      'Source client %{sourceName} has no configuration settings to clone. The current form for %{targetName} remains unchanged.',
    CONFIG_NO_CLIENT_NUMBER: 'Client has no ID to load configuration.',
    CONFIG_CLONE_CANCELLED: 'Clone operation cancelled.',
    START_DATE_IN_FUTURE: 'Start date cannot be more than one week in the future.',
    END_DATE_IN_FUTURE: 'End date cannot be more than one week in the future.',
    START_OR_END_DATE_IN_FUTURE: 'Start or end date cannot be more than a week in the future.',
    START_DATE_AFTER_END: 'Start date must be before end date.',
    END_DATE_BEFORE_START: 'End date cannot be before the start date.',
    DATE_ENDS_IN_FUTURE: 'Selected date range ends in the future.',
    PA_DATE_IN_FUTURE: 'For PA reports, you can only select months up to the current month.',
    ASSIST_DATE_IN_FUTURE: 'For Assist reports, you can only select months up to the current month.',
    CONFIG_ALREADY_CLONED_SAME: 'The current settings already match the selected source.',
    TPA_FETCH_ERROR: 'Error: Could not fetch TPA list',
    CHECK_PA_REVIEW_EXISTS:
      'A PA Review report must be created for this billing date before generating a PA Client Bill.',
    ERROR_CHECKING_PA_REPORT_EXISTS: 'Error checking report existence',
    SELECT_TPA_WARNING: 'Please select a TPA to continue.',
    REPORT_NOT_CREATED: 'Report was not created.',
    CONFIG_MULTIPLE_TPA_INFO:
      'Cannot load configuration for multiple TPAs. You can create a new one or clone from an existing TPA.',
    SELECT_ROLL_UP_FIRST: 'Please select a "Roll up by" field first.',
    INVOICE_CONFIG_SAVED_SUCCESS: 'Config saved successfully',
    INVOICE_CONFIG_SAVED_ERROR: 'Failed to save config',
    INVOICE_CONFIG_LOADED: 'Loaded saved config',
    INVOICE_CONFIG_DEFAULT: 'Loaded default config',
    INVOICE_ERROR_USING_DEFAULT: 'Error loading config, using default',
    CLIENT_FILTER: {
      FETCH_ERROR: 'Failed to fetch clients',
    },
    CLIENT_SPLIT_NOTIFICATIONS: {
      NO_TPA_FOUND: 'No active TPA found for this client.',
      ERROR_FETCHING_TPA: 'Error fetching TPA data.',
      UNEXPECTED_ERROR: 'An unexpected error occurred.',
      VALIDATION: {
        MISSING_CLIENT_OR_DATE: 'Please select a client and an effective date.',
        MISSING_TPA_FIELDS: 'Please fill out all required TPA Transition fields.',
        INVALID_SPLIT_TYPE: 'Please select a valid split type.',
        SAME_TPA_ERROR: 'Old TPA and New TPA cannot be the same. Please select a different New TPA.',
        SAME_CLIENT_ERROR: 'Old and New client names cannot be identical. Please add the TPA suffix to each.',
        CLIENT_NAME_FORMAT: 'Please use the "Name - TPA" format for both client names.',
      },
      TPA_TRANSITION_SAVED: 'Client split for TPA Transition saved successfully!',
      TPA_TRANSITION_SAVE_ERROR: 'An error occurred while saving the TPA Transition. Please try again.',
      COMBINE: {
        SELECT_ONE: 'Please select at least one client to combine.',
      },
      COMBINE_SAVED: 'Client combine configuration saved successfully.',
    },
    medsub: {
      errors: {
        ADD_AT_LEAST_ONE_FILE: 'Please add at least one file.',
        FILE_OR_COLUMN_MISSING: 'A file or column name is missing from the list.',
        PARSING_FAILED: 'Error parsing files. Please check file format and column names.',
        API_ERROR: 'API returned an error.',
        UNKNOWN_ERROR: 'An error occurred during submission.',
        BATCH_FAILED: 'Upload stopped because one batch failed. Please try again later.',
        DELETE_OLD_CLAIMS_FAILED: 'Failed to delete old claims',
        EMPTY_FILE: 'The file %{filename} is empty.',
        INVALID_FILE: 'The file %{filename} is not a valid Excel or CSV file.',
        NO_SHEET_DATA: 'The file %{filename} has no data in its sheet.',
        NO_CLAIM_DATA: 'The file %{filename} has only headers or no claim data.',
        INVALID_COLUMN: "Invalid column '%{column}' for file %{filename}. Please use a valid Excel column letter.",
        FAILED_TO_CHECK_CLAIMS: 'Failed to check for existing claims.',
      },
      success: {
        SUBMIT_SUCCESS: 'Successfully inserted %{count} claims.',
        OLD_CLAIMS_DELETED: 'Old claims successfully deleted.',
      },
      warnings: {
        FIX_FILE_ERRORS: 'Please fix file errors before submitting.',
      },
    },
    CLIENT_CLEANUP: {
      PREVIEW: {
        NO_PREVIEW_YET: 'Preview data not loaded yet.',
        NO_RECORD_FOUND: 'No preview record found.',
        MANUAL_PREVIEW: 'Note: Manual SQL changes are not reflected in the UI preview.',
      },
      RULES: {
        ADD_ONE_RULE: 'Please add at least one rule.',
        MISSING_FIELDS: 'Rule %{index}: Please select BOTH Field to Update and Source Field.',
        INVALID_NUMBERS: 'Rule %{index}: All numeric fields must contain valid numbers.',
        NEGATIVE_VALUES: 'Rule %{index}: Numeric fields cannot be negative.',
        RIGHT_GT_LEFT: 'Rule %{index}: Right Trim cannot be greater than Left Trim.',
        MIN_GT_LEFT: 'Rule %{index}: Min Length cannot exceed Left Trim.',
      },
      SAVED: 'Client cleanup configuration saved successfully.',
    },
    CLIENT_SPLIT: {
      PREVIEW: {
        LOAD_FIRST: 'Please load preview data first.',
        MISSING_FIELD_TO_SPLIT: 'Rule %{index}: Missing field to split.',
        MISSING_SOURCE_FIELD: 'Rule %{index}: Please select a Source Field.',
        PHARMACY_SELECT_FIRST: 'Rule %{index}: Select identifier type and at least one pharmacy before previewing.',
        NO_ROW_SELECTED: 'Please click "Select Row" for Rule %{index} before selecting from the table.',
        NO_ROW_FOUND: 'Could not find preview row.',
        MUST_ADD_ONE_RULE: 'Please add at least one split rule',
      },
      ROW_SELECT: {
        MUST_SELECT_BUTTON_FIRST: 'Please click "Select Row" on this rule first.',
        PHARMACY_AUTO_DETECT: 'Cannot auto-detect pharmacy match value from preview.',
      },
      SAVE: {
        RULE_INCOMPLETE: 'Rule %{index} is incomplete.',
        PHARMACY_REQUIRED: 'Rule %{index}: Please select identifier type and at least one pharmacy.',
        SUCCESS: 'Split rules saved successfully!',
        FAILED: 'Failed to save split rules',
      },
      PHARMACY: {
        FETCH_ERROR: 'Failed to load Pharmacy list.',
        SELECT_IDENTIFIER_TYPE_FIRST: 'Select Identifier Type first.',
      },
    },
    TPA_TRANSITION: {
      DEACTIVATE: {
        SUCCESS: 'Rule deactivated successfully.',
        FAILED_OR_ALREADY_INACTIVE: 'Failed to deactivate rule or Rule is already inactive.',
      },
    },
    REPORT_EXCEPTION: {
      SUCCESS: '%{reportName} exceptions saved successfully',
      FAILED: 'Failed to save %{reportName} exceptions',
    },
    CLIENT_FTP: {
      UPDATE_SUCCESS: 'FTP configuration updated successfully',
      UPDATE_FAILED: 'Failed to save FTP configuration',
      DELETE_SUCCESS: 'Configuration deleted successfully',
      DELETE_FAILED: 'Delete failed',
    },
    GENERATE_REPORT: {
      LATEST_CLAIM_DATE_ERROR: 'End date is later than the latest available claim date',
    },
  },
  resources: {
    claims: {
      claim_number: 'Claim Number',
      rx_claim_number: 'Rx Claim Number',
      member_id: 'Member ID',
      member_name: 'Member Name',
      cardholder_name: 'Card Holder Name',
      medical_group_number: 'Group Number',
      location_number: 'Location Number',
      rx_number: 'Rx Number',
      ndc: 'NDC',
      drug_name: 'Drug Name',
      pharmacy_nabp: 'NABP',
      pharmacy_npi: 'NPI',
      pharmacy_name: 'Pharmacy Name',
      fill_date: 'Fill Date',
      fill_number: 'Fill Number',
      number_of_refills_authorized: 'No. Of Refills',
      quantity: 'Quantity',
      days_supply: 'Days of Supply',
      claim_cost: 'Cost',
      patient_liability: 'Patient Liability',
      patient_paid: 'Patient Paid',
      other_paid: 'Other Paid',
      plan_paid: 'Plan Paid',
      client_ingredient_cost: 'Ingredient Cost',
      transaction_status: 'Status',
      member_dob: 'DOB',
      member_address: 'Address',
      member_city: 'City',
      member_state: 'State',
      member_zip: 'Zip',
    },
    customers: {
      name: 'Customer |||| Customers',
      fields: {
        orders: 'Orders',
        first_seen: 'First seen',
        full_name: 'Name',
        groups: 'Segments',
        last_seen: 'Last seen',
        last_seen_gte: 'Visited Since',
        name: 'Name',
        total_spent: 'Total spent',
        password: 'Password',
        confirm_password: 'Confirm password',
        stateAbbr: 'State',
      },
      filters: {
        last_visited: 'Last visited',
        today: 'Today',
        this_week: 'This week',
        last_week: 'Last week',
        this_month: 'This month',
        last_month: 'Last month',
        earlier: 'Earlier',
        has_ordered: 'Has ordered',
        has_newsletter: 'Has newsletter',
        group: 'Segment',
      },
      fieldGroups: {
        identity: 'Identity',
        address: 'Address',
        stats: 'Stats',
        history: 'History',
        password: 'Password',
        change_password: 'Change Password',
      },
      page: {
        delete: 'Delete Customer',
      },
      errors: {
        password_mismatch: 'The password confirmation is not the same as the password.',
      },
    },
    orders: {
      name: 'Order |||| Orders',
      amount: '1 order |||| %{smart_count} orders',
      title: 'Order %{reference}',
      fields: {
        basket: {
          delivery: 'Delivery',
          reference: 'Reference',
          quantity: 'Quantity',
          sum: 'Sum',
          tax_rate: 'Tax Rate',
          taxes: 'Tax',
          total: 'Total',
          unit_price: 'Unit Price',
        },
        address: 'Address',
        customer_id: 'Customer',
        date_gte: 'Passed Since',
        date_lte: 'Passed Before',
        nb_items: 'Nb Items',
        total_gte: 'Min amount',
        status: 'Status',
        returned: 'Returned',
      },
      section: {
        order: 'Order',
        customer: 'Customer',
        shipping_address: 'Shipping Address',
        items: 'Items',
        total: 'Totals',
      },
    },
    invoices: {
      name: 'Invoice |||| Invoices',
      fields: {
        date: 'Invoice date',
        customer_id: 'Customer',
        order_id: 'Order',
        date_gte: 'Passed Since',
        date_lte: 'Passed Before',
        total_gte: 'Min amount',
        address: 'Address',
      },
    },
    products: {
      name: 'Poster |||| Posters',
      fields: {
        category_id: 'Category',
        height_gte: 'Min height',
        height_lte: 'Max height',
        height: 'Height',
        image: 'Image',
        price: 'Price',
        reference: 'Reference',
        sales: 'Sales',
        stock_lte: 'Low Stock',
        stock: 'Stock',
        thumbnail: 'Thumbnail',
        width_gte: 'Min width',
        width_lte: 'Max width',
        width: 'Width',
      },
      tabs: {
        image: 'Image',
        details: 'Details',
        description: 'Description',
        reviews: 'Reviews',
      },
      filters: {
        categories: 'Categories',
        stock: 'Stock',
        no_stock: 'Out of stock',
        low_stock: '1 - 9 items',
        average_stock: '10 - 49 items',
        enough_stock: '50 items & more',
        sales: 'Sales',
        best_sellers: 'Best sellers',
        average_sellers: 'Average',
        low_sellers: 'Low',
        never_sold: 'Never sold',
      },
    },
    categories: {
      name: 'Category |||| Categories',
      fields: {
        products: 'Products',
      },
    },
    reviews: {
      name: 'Review |||| Reviews',
      amount: '1 review |||| %{smart_count} reviews',
      relative_to_poster: 'Review on poster',
      detail: 'Review detail',
      fields: {
        customer_id: 'Customer',
        order_id: 'Order',
        product_id: 'Product',
        date_gte: 'Posted since',
        date_lte: 'Posted before',
        date: 'Date',
        comment: 'Comment',
        rating: 'Rating',
      },
      action: {
        accept: 'Accept',
        reject: 'Reject',
      },
      notification: {
        approved_success: 'Review approved',
        approved_error: 'Error: Review not approved',
        rejected_success: 'Review rejected',
        rejected_error: 'Error: Review not rejected',
      },
    },
    segments: {
      name: 'Segment |||| Segments',
      fields: {
        customers: 'Customers',
        name: 'Name',
      },
      data: {
        compulsive: 'Compulsive',
        collector: 'Collector',
        ordered_once: 'Ordered once',
        regular: 'Regular',
        returns: 'Returns',
        reviewer: 'Reviewer',
      },
    },
  },
};

export default customEnglishMessages;
